import { getKey } from "@smartsheet/cufflink";
var ConfigSettingStateService = /** @class */ (function () {
    function ConfigSettingStateService(mgr) {
        this.mgr = mgr;
    }
    ConfigSettingStateService.prototype.getSetting = function (id) {
        return this.mgr.getSetting(id);
    };
    ConfigSettingStateService.prototype.getSettingV3 = function (name) {
        if (this.mgr.getSettingV3) {
            return this.mgr.getSettingV3(name);
        }
        else {
            return null;
        }
    };
    /**
     * Returns true/false if the EAP automation feature is enabled for the user.
     *
     * If the system setting is 0 the feature is off for everyone system wide.
     * If the system setting is 1 we are in EAP and use the EAP settings to determine access.
     * If the system system is 2 the feature is available for all users system wide.
     */
    ConfigSettingStateService.prototype.isEAPFeatureEnabled = function (systemSettingId, orgSettingId, userSettingId) {
        var systemSetting = this.mgr.getSetting(systemSettingId);
        var featureEAPOrgSetting = this.mgr.getSetting(orgSettingId);
        var featureEAPUserSetting = this.mgr.getSetting(userSettingId);
        if (systemSetting == null) {
            return false;
        }
        else if (systemSetting.valueLong === 0) {
            return false;
        }
        else if (systemSetting.valueLong === 1) {
            return ((featureEAPOrgSetting === null || featureEAPOrgSetting === void 0 ? void 0 : featureEAPOrgSetting.valueBoolean) === true &&
                (featureEAPUserSetting === null || featureEAPUserSetting === void 0 ? void 0 : featureEAPUserSetting.valueBoolean) === true);
        }
        else if (systemSetting.valueLong === 2) {
            return true;
        }
        return false;
    };
    return ConfigSettingStateService;
}());
export { ConfigSettingStateService };
export var configSettingStateServiceKey = getKey("config_setting_state_service_v2", ConfigSettingStateService);
//# sourceMappingURL=ConfigSettingStateService.js.map